<template>
<div>
    <div v-if="loading == false">
        <div id="custom-search-input">
            <div class="input-group col-md-2">
                <input
                    type="text"
                    class="search-query form-control"
                    v-model="search"
                    :placeholder="Buscar"
                />
                <span class="input-group-btn">
          <button class="btn btn-danger" type="button">
              <span class=" glyphicon glyphicon-search"></span>
                </button>
                </span>
            </div>
        </div>

        <div class="checkbox">
            <label>{{ $t('ONLY_APPROVED_TRANSACTIONS') }}</label>
        </div>
        <br>
        <div class="box box-primary direct-chat direct-chat-primary">
            <div class="box-body">
                <vue-good-table :columns="columns" :rows="transactions" :search-options="{
                enabled: false,
                trigger: 'enter',
               
                }" :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  dropdownAllowAll: false,
                  nextLabel: $t('TRANSACTION_TABLE.NEXT') ,
                  prevLabel:$t('TRANSACTION_TABLE.BACK') ,
                  ofLabel: $t('TRANSACTION_TABLE.OF') ,
                  rowsPerPageLabel:$t('TRANSACTION_TABLE.ROWS_PER_PAGES'),

                }" styleClass="vgt-table condensed">
                    <template slot="table-column" slot-scope="props">
                        <th v-if="props.column.field == 'Transaction_Date'"> {{ props.column.label | translate }}</th>
                        <th v-if="props.column.field == 'Entity_Id'"> {{ props.column.label | translate }}</th>
                        <th v-if="props.column.field == 'Entity_Name'"> {{ props.column.label | translate }}</th>
                        <th v-if="props.column.field == 'AuthCode'"> {{ props.column.label | translate }}</th>
                        <th v-if="props.column.field == 'Authorization_Id'"> {{ props.column.label | translate }}</th>
                        <th v-if="props.column.field == 'Transaction_Type'"> {{ props.column.label | translate }}</th>
                        <th v-if="props.column.field == 'Aproved_Amount'"> {{ props.column.label | translate }} </th>
                        <th v-if="props.column.field == 'TransactDetails'"> {{ props.column.label | translate }} </th>
                        <th v-if="props.column.field == 'Estado'"> {{ props.column.label | translate }} </th>
                    </template>

                    <template slot="table-row" scope="props">
                        <td v-if="props.column.field == 'Transaction_Date'"> {{ props.row.Transaction_Date | formatDate }}</td>
                        <td v-if="props.column.field == 'Entity_Id'"> {{ props.row.Entity_Id }}</td>
                        <td v-if="props.column.field == 'Entity_Name'"> {{ props.row.Entity_Name }}</td>
                        <td v-if="props.column.field == 'AuthCode'"> {{ props.row.AuthCode }}</td>
                        <td v-if="props.column.field == 'Authorization_Id'"> {{ props.row.Authorization_Id }}</td>
                        <td v-if="props.column.field == 'Transaction_Type'"> {{ props.row.Transaction_Type | translate}}</td>
                        <td v-if="props.column.field == 'Aproved_Amount'"> {{ props.row.Aproved_Amount | Decimal }} </td>
                        <td v-if="props.column.field == 'TransactDetails'">
                            <router-link class="btn btn-default" :to="{ name:'TransactionDetails', params:{ id:props.row.Authorization_Id } }"> {{ $t('DETAILS') }} </router-link>
                        </td>
                        <td v-if="props.column.field == 'Estado'"><button class="btn btn-default"><span><i v-bind:class="props.row.estatus | checkStatus"  style="font-size:30px;"></i></span></button> </td>
                    </template>

                </vue-good-table>
            </div>
        </div>
    </div>
    <div v-else>

        <center>
            <div class="fa fa-spinner fa-pulse text-blue" style="font-size:100px;"></div>
        </center>
    
    </div>

</div>
</template>

<script>
import swal from "sweetalert";
import _ from "lodash";
export default {
    name: "transactions",
    watch: {
        search: _.debounce(function (newVal) {
            this.searchingTransact();
        }, 1000)
    },
    data() {
        return {
            check: false,
            Buscar: this.$t("SEARCH"),
            columns: [{
                    label: "TRANSACTION_TABLE.COLUMS.DATE",
                    field: "Transaction_Date"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.ENTITY_ID",
                    field: "Entity_Id",
                    type: "number"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.ENTITY_NAME",
                    field: "Entity_Name"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.TRANSACTION_ID",
                    field: "Authorization_Id"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.TRANSACTION_TYPE",
                    field: "Transaction_Type"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.APPROVED_AMOUNT",
                    field: "Aproved_Amount",
                    tdClass: "text-center"
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.AUTH_CODE",
                    field: "AuthCode",
                    type: "string",
                    tdClass: "text-center",
                    html: true
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.TRANSATION_DETAILS",
                    field: "TransactDetails",
                    html: true
                },
                {
                    label: "TRANSACTION_TABLE.COLUMS.STATUS",
                    field: "Estado",
                    tdClass: "text-center",
                    html: true
                }
            ],
            loading: false,
            transactions: [],
            statusColor: "",
            oldTransact: [],
            search: ""
        };
    },
    created() {
        let self = this;
        self.getAll();
        if (this.check == true) {}
    },
    methods: {
        async console() {
            let self = this;
            self.loading = true;

            if (self.check == true) {
                self.transactions = await this.charginData(self.transactions);
            } else {
                self.transactions = await this.charginData(self.oldTransact);
            }
            self.loading = false;
        },
        charginData(allTransaction) {
            let self = this;
            return new Promise((resolve, reject) => {
                let show = [];

                for (let transact of allTransaction) {
                    if (self.check === true) {
                        if (transact.CreditCardLogStatusId == 1) {
                            if (self.$route.name == "Home") {
                                show.push(transact);
                            } else if (
                                self.$route.name == "Without-request" &&
                                transact.estatus == "Sin-peticion"
                            ) {
                                show.push(transact);
                            } else if (
                                self.$route.name == "Pending" &&
                                transact.estatus == "Pendiente"
                            ) {
                                show.push(transact);
                            } else if (
                                self.$route.name == "Approved" &&
                                transact.estatus == "Aprobado"
                            ) {
                                show.push(transact);
                            } else if (
                                self.$route.name == "rejected" &&
                                transact.estatus == "Rechazado"
                            ) {
                                show.push(transact);
                            }
                        }
                    } else {
                        if (self.$route.name == "Home") {
                            show.push(transact);
                        } else if (
                            self.$route.name == "Without-request" &&
                            transact.estatus == "Sin-peticion"
                        ) {
                            show.push(transact);
                        } else if (
                            self.$route.name == "Pending" &&
                            transact.estatus == "Pendiente"
                        ) {
                            show.push(transact);
                        } else if (
                            self.$route.name == "Approved" &&
                            transact.estatus == "Aprobado"
                        ) {
                            show.push(transact);
                        } else if (
                            self.$route.name == "rejected" &&
                            transact.estatus == "Rechazado"
                        ) {
                            show.push(transact);
                        }
                    }
                }

                resolve(show);
            });
        },
        async getAll() {
            let self = this;
            self.loading = true;
            try {
                let allTransaction = await self.$store.state.services.transactionService.getAll(
                    JSON.parse(self.$store.getters.user).token
                );

                self.transactions = await this.charginData(allTransaction.data);
                self.oldTransact = await allTransaction.data;
                self.loading = false;
            } catch (reason) {
                swal({
                    title: reason.response.data.error,
                    icon: "warning",
                    dangerMode: false
                }).then(clicket => {
                    self.loading = false;
                });
            }
        },
        async searchingTransact() {
            let self = this;
            self.loading = true;
            try {
                
                let data = await self.$store.state.services.transactionService.getOne(
                    this.search,
                    JSON.parse(self.$store.getters.user).token
                );
                if(data.data == ""){
                  swal({
                    title:`La Transaccion con el id ${self.search} no ha sido encontrada.`,
                    icon: "warning",
                    dangerMode: false
                }).then(clicket => {
                    self.loading = false;
                });
                }else{
                this.transactions = [data.data];
                console.log({data})
                }
                self.loading = false;
            } catch (reason) {
                swal({
                    title: reason.response.data.error,
                    icon: "warning",
                    dangerMode: false
                }).then(clicket => {
                    self.loading = false;
                });
            }
            /*this.oldTransact.filter(transaction => {
              return (
                transaction.Entity_Id.match(this.search) ||
                transaction.Authorization_Id.match(this.search)
              );
            });*/
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/partials/transactions.vue